import { memo, type FC } from "react";
import StyledDropdown from "src/components/reusable/StyledDropdown";
import CampaignFormField from "./CampaignFormField";
import { getFieldErrorId, useRequiredFieldError } from "./UseRequiredFieldError";

export interface CampaignSelectOption {
  value: string;
  label: string;
}

interface CampaignSelectFieldProps {
  id: string;
  label: string;
  value: string | null;
  options: CampaignSelectOption[];
  onChange: (_value: string) => void;
  placeholder?: string;
  required?: boolean;
}

const CampaignSelectField: FC<CampaignSelectFieldProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  placeholder,
  required = false,
}) => {
  const { hasError, handleBlur } = useRequiredFieldError(value, required);

  return (
    <CampaignFormField label={label} htmlFor={id} required={required} hasError={hasError}>
      <StyledDropdown
        id={id}
        value={value ?? undefined}
        options={options}
        onChange={onChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        aria-invalid={hasError}
        aria-describedby={hasError ? getFieldErrorId(id) : undefined}
        className="campaign-flow__select"
        popupClassName="campaign-flow__popup"
      />
    </CampaignFormField>
  );
};

export default memo(CampaignSelectField);
